module.exports = __webpack_public_path__ + "d17.no2.1c5982ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d17.no2.jpg
// module id = g4e6
// module chunks = 0